// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fontSans_b59d88', '__fontSans_Fallback_b59d88'"},"className":"__className_b59d88","variable":"__variable_b59d88"};